import NavBar from './components/NavBar';
import Home from './components/Home';
import WorkExperience from './components/WorkExperience';
import Portfolio from './components/Portfolio';
import Skills from './components/Skills';
import Certifications from './components/Certifications';
import Contact from './components/Contact';
import SocialLinks from './components/SocialLinks';

function App() {
  return (
    <div>
      <NavBar />
      <Home />
      <WorkExperience />
      <Portfolio />
      <Skills />
      <Certifications />
      <Contact />
      <SocialLinks />
    </div>
  );
}

export default App;
